import { render, staticRenderFns } from "./InstantMarketingGrid.vue?vue&type=template&id=f6d2c260&"
import script from "./InstantMarketingGrid.vue?vue&type=script&lang=js&"
export * from "./InstantMarketingGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports